// extracted by mini-css-extract-plugin
module.exports = {"modal-message-wrapper":"src-components-CrudModal-styles__modal-message-wrapper--33tPa","modal-message-text":"src-components-CrudModal-styles__modal-message-text--2vDys"};